import React from "react";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/pennywort_juice.png";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function PennywortJuice() {
  useMetaTracking("ViewContent", {
    content_name: "Pennywort Juice",
    content_category: "Drinks",
    content_ids: ["pennywort_juice"],
    content_type: "drinks",
    value: 7.00,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Pennywort Juice (Rau Má) | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Refresh and rejuvenate with our authentic Pennywort Juice (Rau Má), a traditional Vietnamese herbal beverage. Made with fresh pennywort leaves and a touch of sweetness, this cooling drink is believed to soothe the body and mind. Perfect for a hot day or as a natural wellness boost."
        />
        <meta
          property="og:title"
          content="Pennywort Juice (Rau Má) | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Refresh and rejuvenate with our authentic Pennywort Juice (Rau Má), a traditional Vietnamese herbal beverage. Made with fresh pennywort leaves and a touch of sweetness, this cooling drink is believed to soothe the body and mind."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="PENNYWORT JUICE"
          titleSubHead="$7.00 each"
          detailBody="Refresh and rejuvenate with our authentic Pennywort Juice (Rau Má), a traditional Vietnamese herbal beverage. Made with fresh pennywort leaves and a touch of sweetness, this cooling drink is believed to soothe the body and mind. Perfect for a hot day or as a natural wellness boost!"
          detailBodyBr="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default PennywortJuice;